import { $fetch } from '@/boot/fetch'

const endpoint = '/returns'

/**
 * PEG-786 Source 3 — AI dynamic questions injected into the return flow.
 * Backend: GET /v1/returns/:returnSessionId/dynamic-questions and
 * POST /v1/returns/dynamic-questions/:questionId/answer.
 */
export default {
  /**
   * @description Generate (idempotent) + fetch the AI dynamic questions for a
   * return session. Each question: { id, returnSessionItemId, questionText,
   * questionType: 'YES_NO' | 'MULTIPLE_CHOICE', choicesJson, answer, answeredAt }.
   * @function getForSession
   * @param {string} returnSessionId
   * @returns {Promise} - $fetch.peg flattens res.data, so callers receive
   *   { questions: [...] } (no `data` wrapper). Throws on non-2xx — callers
   *   must use try/catch (per AGENTS.md API Layer).
   */
  getForSession(returnSessionId) {
    return $fetch.peg(`${endpoint}/${returnSessionId}/dynamic-questions`, {
      method: 'GET',
    })
  },

  /**
   * @description Record the customer's answer to a dynamic question. The
   * backend writes answer + answered_at and, when the answer confirms the
   * non-returnable condition, blocks the return and logs a
   * return_blocked_attempts row (validation_source='AI_DYNAMIC_QUESTION').
   * @function answer
   * @param {string} questionId
   * @param {string} answer
   * @returns {Promise} - $fetch.peg flattens res.data, so callers receive
   *   { question, blocked } (no `data` wrapper). Throws on non-2xx — callers
   *   must use try/catch (per AGENTS.md API Layer).
   */
  answer(questionId, answer) {
    return $fetch.peg(`${endpoint}/dynamic-questions/${questionId}/answer`, {
      method: 'POST',
      body: { answer },
    })
  },
}
